module.exports = __webpack_public_path__ + "images/8642937865001d45b802b42079af281btruck.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/truck.png
// module id = T0TH
// module chunks = 0